import { Icon } from '@blueprintjs/core';
import classNames from 'classnames';
import React, { SetStateAction } from 'react'
import { getStatusConfig } from 'redux/app/tool/utils';

type TStatusMenuProps = {
	type: "Signal" | "IMOS";
	setStatusModalOpen: React.Dispatch<SetStateAction<boolean>>;
	setErrorDetails: React.Dispatch<SetStateAction<any>>;
	report: any;
	reportItem: any;
	index: number;
	report_type: string;
	lastProcessedDate: string;
	offset: { sm: number; lg: number };
}

function StatusMenu(props: TStatusMenuProps) {
	const {
		type,
		setStatusModalOpen,
		setErrorDetails,
		report,
		reportItem,
		index,
		report_type,
		lastProcessedDate,
		offset,
	} = props;
	const imosApiResponse = report_type === "DELAY_OFFHIRE_NOTICE" ? report?.standaloneForm?.delayOffHireNotice?.imosApiResponse : reportItem?.imosApiResponse;
	const signalApiResponse = reportItem?.signalApiResponse;


	// For special cases in noon report. Ensures that we show "N/A" rather than "Processing"
	function isStatusNA(timeline: any, index: number) {
		const currentReport = timeline[index];
		const reportType = currentReport?.report_type;

		// Check if there are more reports after the current one
		if (index < timeline.length - 1) {
			// Case 1: Steaming followed by Arrival -> show "N/A" in Steaming
			if (reportType === "STEAMING") {
				const nextReport = timeline[index + 1];
				if (nextReport?.report_type === "ARRIVAL") {
					return true;
				}
			}

			// Case 2: Port + Departure -> show "N/A" in Port
			if (reportType === "PORT") {
				const nextReport = timeline[index + 1];
				if (nextReport?.report_type === "DEPARTURE") {
					return true;
				}
			}
		}
		return false;
	}

	const isImosDeferred = report?.imosApiStatus === "DEFERRED";
	const deferredImosDetails = {
		formID: null,
		success: false,
		formStatus: "DEFERRED",
		formErrors: null,
		message: "Deferred during SG/London office peak hours",
	};

	const config = type === "Signal"
		? getStatusConfig(signalApiResponse, signalApiResponse?.id || signalApiResponse?.signalApiResponse === 200, report?.doc_status)
		: getStatusConfig(imosApiResponse, imosApiResponse?.success, report?.doc_status, isStatusNA(report?.timeline, index), isImosDeferred);

	const imosErrorDetails = {
		reportName: report_type,
		errorDetails: imosApiResponse || (isImosDeferred ? deferredImosDetails : undefined),
		lastProcessedDate: lastProcessedDate,
		reportType: type,
		docId: report?._id,
		vesselId: report?.vesselId,
		doc_status: report?.doc_status,
		config: config,
	}

	const signalErrorDetails = {
		reportName: report_type,
		errorDetails: {
			formID: signalApiResponse?.id,
			message: signalApiResponse?.detail
				? signalApiResponse?.detail
				: JSON.stringify(signalApiResponse),
			success: signalApiResponse?.id ? true
				: signalApiResponse?.detail ? false
					: undefined,
		},
		lastProcessedDate: lastProcessedDate,
		reportType: type,
		docId: report._id,
		vesselId: report.vesselId,
		doc_status: report.doc_status,
		config: config,
	}

	return (
		<>
			<td
				className={classNames(
					"border text-[8px] lg:text-[10px] xl:text-[12px] text-gray-600 px-2 lg:px-2 min-w-10 lg:min-w-32 sticky z-1 bg-white cursor-pointer",
				)}
				style={{ right: window.innerWidth < 1024 ? offset.sm : offset.lg }}
			>
				<div
					className={`relative flex gap-2 justify-center items-center p-1 lg:p-2 rounded-md border font-medium ${config?.className}`}
					onClick={() => {
						setErrorDetails(type === "Signal" ? signalErrorDetails : imosErrorDetails);
						setStatusModalOpen(true)
					}}
				>
					<Icon icon={config.icon} size={window.innerWidth < 1024 ? 12 : 16} />
					<span className='hidden lg:block'>{config?.label}</span>
				</div>
			</td >
		</>
	)
}

export default StatusMenu